/*
*   自定义菜单组件
*/
import React , { Component } from 'react';
import {
    SettingOutlined,
    AimOutlined,
    LineOutlined,
    VideoCameraOutlined,
    LineChartOutlined,
    MessageOutlined
} from '@ant-design/icons';
import { Layout, Menu, Image } from 'antd';
import CNF from '../../incs/Config';

import LOGO from '../../images/logo.png';
const { Sider } = Layout;

const rootSubmenuKeys = ['sub1','sub2','sub3','sub4','sub5','sub6'];

function getItem(label, key, icon, children, type) {
    return { key, icon, children, label, type,};
}

function getDefaultOpenKey(m){
    var openKeys = [];
    if(m > 100){
        //  三级菜单
        let i = Math.floor(parseInt(m) / 100);
        let j = parseInt((m % 100)/10);
        openKeys.push(CNF.navItems[i - 1].sub);
        openKeys.push(CNF.navItems[i - 1].submenu[j - 1].sub);
    }else if(m > 10){
        openKeys.push(CNF.navItems[parseInt(m / 10) - 1].sub);
    }else{
        openKeys.push(CNF.navItems[parseInt(m) - 1].sub);
    }
    return openKeys;
}

function icon(m){
    switch(m){
        case 1:
            return <SettingOutlined />
        case 2:
            return <AimOutlined />
        case 3:
            return <LineOutlined />
        case 4:
            return <VideoCameraOutlined />
        case 5:
            return <LineChartOutlined />
        case 6:
            return <MessageOutlined />
        default:
            return null
    }
}

class SYMenu extends Component{
    constructor(props){
        super(props);
        this.state = {
            collapsed: false,
            openKeys: getDefaultOpenKey(this.props.m),
            current: this.props.m.toString(),
        }
    }
    setCollapsed = () => { this.setState({ collapsed: !this.state.collapsed }); }
    setOpenKeys = (keys) => {
        this.setState({ openKeys: keys });}
    onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => this.state.openKeys.indexOf(key) === -1);
        if(latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setOpenKeys(keys);
        }else if((latestOpenKey && latestOpenKey.indexOf('-') >= 0)||(latestOpenKey===undefined)){
            this.setOpenKeys(keys);
        }else{
            this.setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };
    handleOnClick = (e) => {
        if(e.key<10){
            this.setOpenKeys([]);
        }
        this.setState({ current: e.key });
        this.props.changeNavItemM(e.key)
    };

    render(){
        var items = [];
        for(var i=0; i<CNF.navItems.length; i++){
            var item = CNF.navItems[i];
            //  根据权限加载导航菜单
            if(this.props.btnLists.indexOf(item.ptn) >= 0 && (item.hasOwnProperty('ptn2')?this.props.btnLists.indexOf(item['ptn2']) >= 0:true)){
                if(item['submenu'].toString() === ''){
                    //  一级菜单
                    items.push(getItem(item['name'], item['m'], icon(item['m'])))
                }else{
                    //  二级菜单
                    let sub2_arr = []
                    for(let j=0; j<item.submenu.length; j++){
                        let sub2_item = item.submenu[j];
                        if(this.props.btnLists.indexOf(sub2_item.ptn) >= 0  && (sub2_item.hasOwnProperty('ptn2')?this.props.btnLists.indexOf(sub2_item['ptn2']) >= 0:true)){
                            //  三级菜单
                            if(sub2_item.hasOwnProperty('submenu')){
                                let sub3_arr = [];
                                for(let k=0; k<sub2_item.submenu.length; k++){
                                    let sub3_item = sub2_item.submenu[k];
                                    if(this.props.btnLists.indexOf(sub3_item.ptn) >= 0 && (sub3_item.hasOwnProperty('ptn2')?this.props.btnLists.indexOf(sub3_item['ptn2']) >= 0:true)){
                                        sub3_arr.push(getItem(sub3_item['name'], sub3_item['m']));
                                    }
                                }
                                sub2_arr.push(getItem(sub2_item['name'],sub2_item['sub'], null ,sub3_arr))
                            }else{
                                if(this.props.btnLists.indexOf(sub2_item.ptn) >= 0  && (sub2_item.hasOwnProperty('ptn2')?this.props.btnLists.indexOf(sub2_item['ptn2']) >= 0:true)){
                                    sub2_arr.push(getItem(sub2_item['name'], sub2_item['m']));
                                }
                            }
                        }
                    }
                    items.push(getItem(item['name'],item['sub'], icon(item['m']) ,sub2_arr))
                }
            }
        }

        return (
            <Sider trigger={null} collapsible collapsed={this.props.collapsed}>
                <div style={{height: '64px', overflow:'hidden'}}>
                    <div style={{
                        'float': 'left',
                        'height': '64px',
                        'width': '80px', 
                        padding: '12px 20px 0 21px'
                    }}>
                        <Image width={35} preview={false} src={LOGO}/>
                    </div>
                    <div style={{
                        color: '#ffffff', 
                        height: '64px', 
                        lineHeight: '64px',
                        padding: '0 20px 0 20px',
                        fontSize: '15px'
                        }}>{!this.state.collapsed?`${CNF.projectCode} ${CNF.version}`:''}</div>
                </div>
                <Menu
                    theme='dark'
                    mode='inline'
                    defaultSelectedKeys={['0']}
                    openKeys={this.state.openKeys}
                    onOpenChange={this.onOpenChange}
                    selectedKeys={[this.state.current]}
                    onClick={this.handleOnClick}
                    items={items}
                />
            </Sider>
        );
    };
}
export default SYMenu;